import SelectedPostImages from '@components/PostImageSelector/SelectedPostImages';
import SelectedPostVideos from '@components/PostVideoSelector/SelectedPostVideos';
import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CampaignType } from '../../constants/postType.constants';
import GivingLevelForm from '../Campaign/GivingLevelForm';
import PostViewersSelector from '../PostViewerSelector/PostViewersSelector';
import PostNotify from '../next-page-components/PostNotify';
import PostType from '@/constants/postType.constants';
import OrgType from '@/constants/orgType.constant';
import TextArea from '../next-ui/TextArea';
import Input from '../next-ui/Input';
import useStore from '@/stores/store';

function CampaignProjectForm(props) {
  const { images, videos, edit } = props;
  const userProfile = useStore((state) => state.user.profile);

  const formMethods = useFormContext();
  const {
    control,
    formState: { errors },
    trigger,
    watch,
    getValues,
  } = formMethods;

  const campaignType = watch('campaignType');

  // Trigger validation on name change when editing
  useEffect(() => {
    const isEdit = getValues('name') !== '';
    if (isEdit) {
      trigger(); // Trigger validation if editing
    }
  }, []);

  return (
    <div className="flex w-full flex-col gap-6">
      <Box>
        <PostViewersSelector disabled={edit} />
      </Box>
      <div>
        <PostNotify
          postType={PostType.Project}
          orgId={userProfile?.activeCommunity?.nonProfit?.id}
          orgType={OrgType.NonProfit}
        />
      </div>
      <Controller
        control={control}
        name="name"
        render={({ field }) => (
          <Input
            {...field}
            label="NAME"
            placeholder="Name of project..."
            error={errors.name?.message}
            required
          />
        )}
      />
      <Stack
        sx={{
          flexDirection: { xs: 'column', sm: 'row' },
        }}
        gap={2}
        flexWrap="nowrap"
        alignItems="center"
        justifyContent="space-between"
        width="100%">
        <Box flexGrow={1} width="100%">
          <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <TextArea
                {...field}
                label="DESCRIPTION"
                placeholder="Enter description"
                rows={3}
                className="w-full"
                error={errors.description?.message}
                required
              />
            )}
          />
        </Box>

        {campaignType === CampaignType.CollectGoods && (
          <Box flexGrow={1} width="100%">
            <Controller
              control={control}
              name="address"
              render={({ field }) => (
                <TextArea
                  {...field}
                  label="ADDRESS"
                  placeholder="Enter the address"
                  rows={3}
                  className="w-full"
                  error={errors.address?.message}
                  required
                />
              )}
            />
          </Box>
        )}
      </Stack>
      <Box width="100%">
        <SelectedPostImages images={images} />
      </Box>
      <Box width="100%">
        <SelectedPostVideos videos={videos} />
      </Box>
      <Typography variant="h6">Giving Opportunities</Typography>
      <Box width="100%">
        <GivingLevelForm type={campaignType} edit={edit} />
      </Box>
    </div>
  );
}

export default CampaignProjectForm;
